module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif((model.projectImmos || []).length <= 0){\nadditionalClasses.push('emptyObjectList');\n}\nelse {\nmodel.projectImmos = model.projectImmos.sort(function(a, b){\nif(a.price && b.price){\nconst ap = a.price * 1;\nconst bp = b.price * 1;\nif(!isNaN(ap) && !isNaN(bp)){\nif(ap < bp) return -1\nif(ap > bp) return 1\n}\n}\nreturn 0\n})\n}\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<h2><%= model.title %></h2>\n<div class=\"filter\">\n<h4>Objektart Auswahl</h4>\n<%- include('./categoryFilter', { model: model, config: config }); %>\n</div>\n<div class=\"list\">\n<table>\n<tbody>\n<%\nvar pi, projectImmo;\nvar odd = true;\nfor(pi in model.projectImmos || []){\nprojectImmo = model.projectImmos[pi];\n%>\n<tr class=\"<%= odd ? 'odd' : 'even' %>\" data-route-id=\"<%= projectImmo.routeID %>\" data-cat-id=\"<%= projectImmo.catID %>\">\n<td class=\"title\"><%- projectImmo.title %></td>\n<td class=\"price\">&euro;&nbsp;<%- parseFloat(String(projectImmo.price || '0').toString().replace(/[^\\d\\.]/g, \"\")).toFixed(2).toString().replace('\\.', ',').replace(/(\\d)(?=(\\d\\d\\d)+(?!\\d))/g, '$1.') %></td>\n</tr>\n<%\nodd = !odd;\n}\n%>\n</tbody>\n</table>\n</div>\n</div>"
  , __filename = "components/templates/project/objectList/objectList.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if((model.projectImmos || []).length <= 0){
additionalClasses.push('emptyObjectList');
}
else {
model.projectImmos = model.projectImmos.sort(function(a, b){
if(a.price && b.price){
const ap = a.price * 1;
const bp = b.price * 1;
if(!isNaN(ap) && !isNaN(bp)){
if(ap < bp) return -1
if(ap > bp) return 1
}
}
return 0
})
}

    ; __line = 19
    ; __append("\n<div class=\"")
    ; __line = 20
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<h2>")
    ; __line = 21
    ; __append(escapeFn( model.title ))
    ; __append("</h2>\n<div class=\"filter\">\n<h4>Objektart Auswahl</h4>\n")
    ; __line = 24
    ; __append( include('./categoryFilter', { model: model, config: config }) )
    ; __append("\n</div>\n<div class=\"list\">\n<table>\n<tbody>\n")
    ; __line = 29
    ; 
var pi, projectImmo;
var odd = true;
for(pi in model.projectImmos || []){
projectImmo = model.projectImmos[pi];

    ; __line = 34
    ; __append("\n<tr class=\"")
    ; __line = 35
    ; __append(escapeFn( odd ? 'odd' : 'even' ))
    ; __append("\" data-route-id=\"")
    ; __append(escapeFn( projectImmo.routeID ))
    ; __append("\" data-cat-id=\"")
    ; __append(escapeFn( projectImmo.catID ))
    ; __append("\">\n<td class=\"title\">")
    ; __line = 36
    ; __append( projectImmo.title )
    ; __append("</td>\n<td class=\"price\">&euro;&nbsp;")
    ; __line = 37
    ; __append( parseFloat(String(projectImmo.price || '0').toString().replace(/[^\d\.]/g, "")).toFixed(2).toString().replace('\.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') )
    ; __append("</td>\n</tr>\n")
    ; __line = 39
    ; 
odd = !odd;
}

    ; __line = 42
    ; __append("\n</tbody>\n</table>\n</div>\n</div>")
    ; __line = 46
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/objectList/objectList.ejs

}